<template>
  <div class="step-regras">
    <!-- Tipo de Regra -->
    <div class="step-regras__section">
      <div class="section-label">Tipo de regra</div>
      <TipoRegraCards
        :value="item.tipo"
        :validacao="item.validacao"
        :disabled="isErpLocked"
        @input="onTipoChange"
      />
      <div class="message">{{ validacao.firstError("item.tipo") }}</div>
    </div>

    <!-- Configurações -->
    <div class="step-regras__section">
      <div class="section-label">Configurações</div>
      <div class="step-regras__toggles">
        <BooleanToggle
          :label="item.tipo === 'MIX' ? 'Pedido precisa ter todos os produtos?' : 'Todas as regras precisam ser válidas?'"
          :help="item.tipo === 'MIX' ? configHelp.validarTodasRegrasMix : configHelp.validarTodasRegras"
          :value="item.validarTodasRegras"
          :disabled="isErpLocked"
          @input="item.validarTodasRegras = $event"
        />

        <BooleanToggle
          v-if="item.tipo === 'SEGMENTACAO' || item.tipo === 'PERSONALIZADO'"
          label="Usar validação por regra?"
          :help="configHelp.validarPorRegra"
          :value="item.validarPorRegra"
          :disabled="isErpLocked"
          @input="item.validarPorRegra = $event"
        />

        <BooleanToggle
          label="Considera quantidade de estoque?"
          :help="configHelp.consideraQtdeEstoque"
          :value="item.consideraQtdeEstoque"
          :disabled="isErpLocked"
          @input="item.consideraQtdeEstoque = $event"
        />

        <BooleanToggle
          label="Valida sobre promoção?"
          :help="configHelp.validaSobrePromocao"
          :value="item.validaSobrePromocao"
          :disabled="isErpLocked"
          @input="item.validaSobrePromocao = $event"
        />

        <BooleanToggle
          label="Aplica sobre promoção?"
          :help="configHelp.aplicarSobrePromocao"
          :value="item.aplicarSobrePromocao"
          :disabled="isErpLocked"
          @input="item.aplicarSobrePromocao = $event"
        />

        <BooleanToggle
          v-if="item.tipo === 'SEGMENTACAO' || item.tipo === 'PERSONALIZADO'"
          label="Acumular descontos?"
          :help="configHelp.acumulaDesconto"
          :value="item.acumulaDesconto"
          :disabled="isErpLocked"
          @input="item.acumulaDesconto = $event"
        />

        <BooleanToggle
          v-if="item.tipo === 'SEGMENTACAO' || item.tipo === 'PERSONALIZADO'"
          label="Usar validação de não compra?"
          :help="configHelp.usaNaoCompra"
          :value="item.usaNaoCompra"
          :disabled="isErpLocked"
          @input="item.usaNaoCompra = $event"
        />
      </div>
    </div>

    <!-- Rule builder - Segmentação -->
    <div v-if="item.tipo === 'SEGMENTACAO'" class="step-regras__section">
      <div class="section-label">Regras de segmento</div>
      <RegraSegmento
        :campanha="item"
        :validacao="validacao"
        :dimensoes="dimensoes"
        :tiposInputs="tiposInputs"
        :showAdicionarRegraButton="!isErpLocked"
      />
      <div class="message">{{ validacao.firstError("item.dimensoes") }}</div>
    </div>

    <!-- Rule builder - Personalizado (Combo) -->
    <div v-if="item.tipo === 'PERSONALIZADO'" class="step-regras__section">
      <div class="section-label">Regras personalizadas</div>
      <RegraPersonalizada
        :campanha="item"
        :validacao="validacao"
        :dimensoes="dimensoes"
        :tiposInputs="tiposInputs"
      />
      <div class="message">{{ validacao.firstError("item.dimensoes") }}</div>
    </div>

    <!-- Rule builder - Mix -->
    <div v-if="item.tipo === 'MIX'" class="step-regras__section">
      <div class="section-label">Produtos do mix</div>
      <ListaProdutos
        :campanha="item"
        :itemsSelected="item.mixProdutos"
        :select-callback="addProdutoMix"
        :deselect-callback="removeProdutoMix"
        :updatePercentageCallback="updateProdutoMixPercentage"
      />
      <div class="message">{{ validacao.firstError("item.mixProdutos") }}</div>
    </div>
  </div>
</template>

<script>
import _remove from "lodash/remove";
import TipoRegraCards from "../shared/TipoRegraCards.vue";
import BooleanToggle from "../shared/BooleanToggle.vue";
import RegraSegmento from "../components/Regra/RegraSegmento.vue";
import RegraPersonalizada from "../components/Regra/RegraPersonalizada/RegraPersonalizada.vue";
import ListaProdutos from "../components/Regra/ListaProdutos.vue";
import { resetValidacaoPorTipo } from "@/helpers/campanhas";
import { CONFIG_HELP } from "../helpers/campanhaLabels";

export default {
  name: "StepRegras",
  components: {
    TipoRegraCards,
    BooleanToggle,
    RegraSegmento,
    RegraPersonalizada,
    ListaProdutos,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    dimensoes: {
      type: Array,
      default: () => [],
    },
    validacao: {
      type: Object,
      required: true,
    },
    isErpLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configHelp: CONFIG_HELP,
      tiposInputs: {
        QT: ["qtdeMin", "qtdeMax"],
        QD: ["qtdeMinDistinta", "qtdeMaxDistinta"],
        VD: ["vlMin", "vlMax", "qtdeMinDistinta", "qtdeMaxDistinta"],
        VQ: ["vlMin", "vlMax", "qtdeMin", "qtdeMax"],
        VL: ["vlMin", "vlMax"],
        QQ: ["qtdeMin", "qtdeMax", "qtdeMinDistinta", "qtdeMaxDistinta"],
        XX: [
          "vlMin",
          "vlMax",
          "qtdeMinDistinta",
          "qtdeMaxDistinta",
          "qtdeMin",
          "qtdeMax",
        ],
        PM: ["percMin", "percMax"],
        PMD: ["percMin", "percMax"],
      },
    };
  },
  watch: {
    "item.tipo"(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (newVal === "MIX") {
        this.item.validarPorRegra = false;
      }
      resetValidacaoPorTipo(this.item, this.validacao);
    },
  },
  methods: {
    onTipoChange(value) {
      if (value === this.item.tipo) return;

      const temRegras =
        (this.item.tipo === "MIX" &&
          Array.isArray(this.item.mixProdutos) &&
          this.item.mixProdutos.length > 0) ||
        ((this.item.tipo === "SEGMENTACAO" || this.item.tipo === "PERSONALIZADO") &&
          Array.isArray(this.item.dimensoes) &&
          this.item.dimensoes.length > 0);

      if (temRegras) {
        this.$swal({
          title: "Alterar tipo de regra?",
          text: "As regras configuradas serão removidas ao alterar o tipo de regra.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Alterar",
          cancelButtonText: "Cancelar",
        }).then((res) => {
          if (res.value) {
            this.item.dimensoes = [];
            this.item.mixProdutos = [];
            this.item.tipo = value;
          }
        });
      } else {
        this.item.tipo = value;
      }
    },
    addProdutoMix(item) {
      this.item.mixProdutos.push(item);
    },
    removeProdutoMix(id) {
      const produtos = [...this.item.mixProdutos];
      _remove(produtos, (n) => +n.id === +id);
      this.item.mixProdutos = produtos;
    },
    updateProdutoMixPercentage(index, newPercentage) {
      if (
        Array.isArray(this.item.mixProdutos) &&
        this.item.mixProdutos[index]
      ) {
        this.item.mixProdutos[index].percDesc = newPercentage;
      }
    },
  },
};
</script>

<style scoped>
.step-regras__section {
  margin-bottom: 14px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-regras__toggles {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 2px 14px;
}
</style>
